import { Error } from "./error.model";
import { FieldFormat, FieldType } from "./form-template.model";
import { Pagination } from "./pagination.model";

export interface TimesheetDropdownValue {
  dropdownValueId: string;
  value: string;
}

export interface CustomTimesheetField {
  label: string;
  value: string;
  defaultValue: string;
  timesheetFieldId: number;
  type: FieldType;
  format: FieldFormat;
  isRequired: boolean;
  timesheetDropdownValues: TimesheetDropdownValue[]
}

export interface RawTimesheet extends Timesheet {
  checkinDistance: number;
  checkoutDistance: number;
}

export interface TimesheetList {
  clientTimesheets: Timesheet[],
  pagination: Pagination,
  errors: Error[],
}

export enum TriState {
  false = 0,
  true = 1,
  na = -1
}

export interface Timesheet {
  status: TriState;
  lunchBreak: boolean;
  _selected?: boolean,
  timesheetId: number,
  staffId: string,
  staffFirstName: string,
  staffMiddleName: string,
  staffLastName: string,
  clientProjectId: number,
  clientProjectName: string,
  calendarBookingId: number,
  calendarDate: Date,
  checkinTime: string,
  checkinDistance: string | number,
  checkoutTime: string,
  checkoutDistance: string | number,
  staffFullName: string,
  customTimesheetFields: CustomTimesheetField[],
  rejectionReason: string,
}

export interface Nav {
  label: string
  link: string
  canVisit: boolean
}

export interface TimesheetApprovals {
  timesheetId: number,
  status: string
}

export interface TimesheetApprovalsRequest {
  timesheetApprovals: TimesheetApprovals[],
  signatureFileId: number
}

export interface SignatureData {
  fileId: number,
  name: string,
  extension: string
}

export interface SaveTimesheetResponse {
  errors: Error[]
}
